import { Form as FormikForm } from 'formik';
import styled from 'styled-components';

export const FormikFormSC = styled(FormikForm)`
  .ui-textfield,
  .ui-textarea,
  .ui-date-picker,
  .ui-range-picker {
    width: 100%;
  }
`;
